import React, { useEffect } from "react";

import Main from '../components/Home/Main'
import GridAfterMain from "../components/Home/GridAfterMain";
import Learn from "../components/Home/Learn";
import Brockerage from "../components/Home/Brockerage";
import EverythingNeed from "../components/Home/EverythingNeed";
import Discover from "../components/Home/Discover";
import ExploreNews from "../components/Home/ExploreNews";
import FAQs from "../components/Home/FAQs";
import Footer from "../components/Footer";

function Home () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="relative overflow-hidden mt-[56px]">
            <Main/>
            <GridAfterMain/>
            <Learn/>
            <Brockerage/>
            <EverythingNeed/>
            <Discover/>
            <ExploreNews/>
            <FAQs/>
            <Footer titleKey="home.49" />
        </div>
    );
}

export default Home;